'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXPANDABLE_PADDING_X = exports.EXPANDABLE_PADDING_TOP = exports.EXPANDABLE_PADDING_LEFT = exports.EXPANDABLE_PADDING_BOTTOM = exports.EXPANDABLE_OPENER_HOVER_COLOR = exports.EXPANDABLE_OPENER_DISABLED_COLOR = exports.EXPANDABLE_OPENER_COLOR = exports.EXPANDABLE_DARK_PADDING_TOP = exports.EXPANDABLE_DARK_BACKGROUND = exports.EXPANDABLE_DARK_BORDER_COLOR = exports.EXPANDABLE_ACTIONS_SPACING_X = undefined;

var _colors = require('HubStyleTokens/colors');

var _theme = require('HubStyleTokens/theme');

var EXPANDABLE_ACTIONS_SPACING_X = exports.EXPANDABLE_ACTIONS_SPACING_X = '8px';
var EXPANDABLE_DARK_BORDER_COLOR = exports.EXPANDABLE_DARK_BORDER_COLOR = _colors.BATTLESHIP;
var EXPANDABLE_DARK_BACKGROUND = exports.EXPANDABLE_DARK_BACKGROUND = _colors.GYPSUM;
var EXPANDABLE_DARK_PADDING_TOP = exports.EXPANDABLE_DARK_PADDING_TOP = '20px';
var EXPANDABLE_OPENER_COLOR = exports.EXPANDABLE_OPENER_COLOR = _colors.CALYPSO;
var EXPANDABLE_OPENER_DISABLED_COLOR = exports.EXPANDABLE_OPENER_DISABLED_COLOR = _theme.BUTTON_DISABLED_TEXT;
var EXPANDABLE_OPENER_HOVER_COLOR = exports.EXPANDABLE_OPENER_HOVER_COLOR = _colors.LINK_HOVER;
var EXPANDABLE_PADDING_BOTTOM = exports.EXPANDABLE_PADDING_BOTTOM = '24px';
var EXPANDABLE_PADDING_LEFT = exports.EXPANDABLE_PADDING_LEFT = '44px';
var EXPANDABLE_PADDING_TOP = exports.EXPANDABLE_PADDING_TOP = '4px';
var EXPANDABLE_PADDING_X = exports.EXPANDABLE_PADDING_X = '20px';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/accordion/ExpandableConstants.js
// module id = 521
// module chunks = 3 4